/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabeAbonnementDto } from '../../models/lexplus-aufgabe-abonnement-dto';

export interface AufgabenControllerFindSubscriptionV1$Params {
  id: number;
}

export function aufgabenControllerFindSubscriptionV1(http: HttpClient, rootUrl: string, params: AufgabenControllerFindSubscriptionV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabeAbonnementDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindSubscriptionV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabeAbonnementDto>;
    })
  );
}

aufgabenControllerFindSubscriptionV1.PATH = '/v1/aufgaben/{id}/subscription';
